import Channel from '@shared/classes/channel';
import EpgEvent from '@shared/classes/epgEvent';
import Plan from '@shared/classes/plan';
import { createContext, MutableRefObject } from 'react';

const ChannelListContext = createContext<{
  callbacks: {
    changeChannel: (index: number) => void;
    navigateEvents: (key: string) => void;
    toggleFloatingMenu: (node: number | null) => void;
  };
  channel: Channel | undefined;
  channelListFocused: boolean;
  setChannelListFocused: (active: boolean) => void;
  complete: boolean;
  event: EpgEvent | undefined;
  focused?: boolean;
  index: number;
  hasMenu: boolean;
  pastEvents: boolean;
  futureEvents: boolean;
  plan: Plan | null;
  pop?: boolean;
  refs?: {
    arrows: MutableRefObject<null>;
    buttons: MutableRefObject<null>;
    list: MutableRefObject<null>;
  } | null;
  onChangeChannel?: (index: number) => void;
  onChangeEvent?: (id?: string, event?: EpgEvent) => void;
}>({
  callbacks: {
    changeChannel: () => null,
    navigateEvents: () => null,
    toggleFloatingMenu: () => null,
  },
  channel: undefined,
  channelListFocused: false,
  setChannelListFocused: ()=>null,
  complete: true,
  event: undefined,
  focused: false,
  hasMenu: true,
  index: 0,
  futureEvents: false,
  pastEvents: false,
  plan: null,
  pop: false,
  refs: null,
  onChangeChannel: () => null,
  onChangeEvent: () => null,
});

export default ChannelListContext;
